<script setup>
import { computed } from 'vue';

const props = defineProps({
    chartType: {
        type: String,
        required: true,
    },
    payload: {
        type: Object,
        required: false,
        default: () => ({}),
    },
    emptyMessage: {
        type: String,
        required: false,
        default: 'No values to show yet.',
    },
});

const previewData = computed(() => props.payload?.data ?? {});

const rows = computed(() => {
    if (props.chartType === 'table' && Array.isArray(previewData.value?.rows)) {
        return previewData.value.rows;
    }

    if (Array.isArray(previewData.value?.distribution)) {
        return previewData.value.distribution;
    }

    return [];
});

const formatSum = (row) => {
    if (typeof row.sum_label === 'string' && row.sum_label !== '') {
        return row.sum_label;
    }

    if (typeof row.sum === 'number') {
        return row.sum.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 6,
        });
    }

    return '-';
};
</script>

<template>
    <div>
        <p v-if="rows.length === 0" class="text-sm">{{ emptyMessage }}</p>

        <div v-else class="overflow-x-auto">
            <table class="w-full text-sm rounded-custom overflow-hidden">
                <thead>
                    <tr>
                        <th class="text-left font-bold p-2 border-b">Field</th>
                        <th class="text-left font-bold p-2 border-b">Total</th>
                    </tr>
                </thead>

                <tbody class="border">
                    <tr v-for="row in rows" :key="row.field_uuid">
                        <td class="p-2 border-b">{{ row.label || row.field_uuid }}</td>
                        <td class="p-2 border-b">{{ formatSum(row) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
